// Environment configuration
// This file centralizes all environment variables and provides defaults

// API URL (backend)
export const API_URL = process.env.REACT_APP_API_URL;

// Base URL (frontend)
export const BASE_URL = process.env.REACT_APP_BASE_URL;

// Telegram Bot Username
export const TELEGRAM_BOT_USERNAME = process.env.REACT_APP_TELEGRAM_BOT_USERNAME;

// Telegram Bot Token
export const TELEGRAM_BOT_TOKEN = process.env.REACT_APP_TELEGRAM_BOT_TOKEN;

// Export as default object
export default {
  API_URL,
  BASE_URL,
  TELEGRAM_BOT_USERNAME,
  TELEGRAM_BOT_TOKEN
};
